import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'

import Home from '@/brochure-site/home.vue'

import Oops from '@/components/_main/oops.vue'

import StaffHome from '@/components/_home-page/staff/home-staff.vue'
import ParticipantHome from '@/components/_home-page/participant/home-participant.vue'
import Welcome from '@/components/welcome-letters/welcome-letter.vue'
import WelcomeEdit from '@/components/welcome-letters/welcome-letter-edit.vue'
import Course from '@/components/course/course-logistics.vue'
import CourseEdit from '@/components/course/course-edit.vue'
import StaffList from '@/components/scouters/staff-list.vue'
import StaffListEdit from '@/components/scouters/staff-edit.vue'
import ParticipantList from '@/components/scouters/participant-list.vue'
import ParticipantListEdit from '@/components/scouters/participant-edit.vue'
import ParticipantBios from '@/components/scouters/participant-bios.vue'
import Patrols from '@/components/patrols/patrols.vue'
import PatrolsEdit from '@/components/patrols/patrols-edit.vue'
import StaffBios from '@/components/scouters/staff-bios.vue'
import Ticket from '@/components/tickets/ticket.vue'
import TicketList from '@/components/tickets/ticket-list.vue'
import TicketListEdit from '@/components/tickets/ticket-counselor-edit.vue'
import Personal from '@/components/scouters/resource-questionnaire.vue'
import PreCourseAssignment from '@/components/precourse-assignments/precourse-assignment.vue'
import StaffDev from '@/components/agendas/staff-development/staff-development.vue'
import StaffDevEdit from '@/components/agendas/staff-development/edit-staff-development.vue'
import CourseSchedule from '@/components/agendas/course-schedule/course-schedule.vue'
import CourseScheduleEdit from '@/components/agendas/course-schedule/edit-course-schedule.vue'
import Presentations from '@/components/presentations/presentation.vue'
import PresentationsEdit from '@/components/presentations/presentation-edit.vue'
import PackingList from '@/components/packing-lists/packing-list.vue'
import PackingListEdit from '@/components/packing-lists/edit-packing-list.vue'
import Faqs from '@/components/faqs/faqs.vue'
import FaqsEdit from '@/components/faqs/faqs-edit.vue'
import Links from '@/components/links/links.vue'
import LinksEdit from '@/components/links/links-edit.vue'
import Help from '@/components/support/help.vue'
import Announcements from '@/components/announcements/announcements.vue'
import AnnouncementsEdit from '@/components/announcements/announcements-edit.vue'

import Reports from '@/components/reports/report.vue'
import Closeout from '@/components/reports/closeout/report-closeout-edit.vue'
import CloseOutPrint from '@/components/reports/closeout/print/report-closeout-generator.vue'
import Finances from '@/components/finance/finances.vue'

import Login from '@/components/security/login.vue'
import CreateCourse from '@/components/course-creation/create-course-wizard.vue'
import AcceptInvitation from '@/components/accept-invitation/invitation-wizard.vue'
import ChangePassword from '@/components/security/password-change.vue'
import ForgotPassword from '@/components/security/password-forgot.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { layout: 'brochure' },
    component: Home
  },
  {
    path: '/oops',
    name: 'oops',
    meta: { layout: 'app' },
    component: Oops
  },
  {
    path: '/change-password',
    name: 'changePassword',
    meta: { layout: 'brochure' },
    component: ChangePassword
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    meta: { layout: 'brochure' },
    component: ForgotPassword
  },
  {
    path: '/create-course',
    name: 'createcourse',
    meta: { layout: 'brochure' },
    component: CreateCourse
  },
  {
    path: '/invitation',
    name: 'invitation',
    meta: { layout: 'brochure' },
    component: AcceptInvitation
  },
  {
    path: '/login',
    name: 'Login',
    meta: { layout: 'brochure' },
    component: Login
  },
  {
    path: '/participant',
    redirect: '/participant/welcome',
    name: 'participant'
  },
  {
    path: '/participant/welcome',
    name: 'Welcome to Wood badge',
    meta: { layout: 'app' },
    component: ParticipantHome
  },
  {
    path: '/participant/announcements',
    name: 'participant announcements',
    meta: { layout: 'app' },
    component: Announcements
  },
  {
    path: '/participant/course',
    name: 'course info',
    meta: { layout: 'app' },
    component: Course
  },
  {
    path: '/participant/ticket',
    name: 'Ticket',
    meta: { layout: 'app' },
    component: Ticket
  },
  {
    path: '/participant/staff-bios',
    name: 'wood badge staff bios',
    meta: { layout: 'app' },
    component: StaffBios
  },
  {
    path: '/participant/personal',
    name: 'resource questionnaire',
    meta: { layout: 'app' },
    component: Personal
  },
  {
    path: '/participant/precourse',
    name: 'Personal Reflection Assignment',
    meta: { layout: 'app' },
    component: PreCourseAssignment
  },
  {
    path: '/participant/packing-list',
    name: 'Packing list',
    meta: { layout: 'app' },
    component: PackingList
  },
  {
    path: '/participant/faqs',
    name: 'Frequently Asked questions',
    meta: { layout: 'app' },
    component: Faqs
  },
  {
    path: '/participant/links',
    name: 'helpful links and files',
    meta: { layout: 'app' },
    component: Links
  },
  {
    path: '/participant/support',
    name: 'participant support info',
    meta: { layout: 'app' },
    component: Help
  },
  {
    path: '/staff',
    redirect: '/staff/dashboard',
    name: 'staff'
  },
  {
    path: '/staff/dashboard',
    name: 'staff dashboard',
    meta: { layout: 'app' },
    component: StaffHome
  },
  {
    path: '/staff/welcome',
    name: 'welcome letter',
    meta: { layout: 'app', editPath: '/staff/welcome/edit' },
    component: Welcome
  },
  {
    path: '/staff/announcements',
    name: 'staff announcements',
    meta: { layout: 'app', editPath: '/staff/announcements/edit' },
    component: Announcements
  },
  {
    path: '/staff/announcements/edit',
    name: 'announcements edit',
    meta: { layout: 'app' },
    component: AnnouncementsEdit
  },
  {
    path: '/staff/welcome/edit',
    name: 'edit welcome letter',
    meta: { layout: 'app' },
    component: WelcomeEdit
  },
  {
    path: '/staff/course',
    name: 'course information',
    meta: { layout: 'app', editPath: '/staff/course/edit' },
    component: Course
  },
  {
    path: '/staff/course/edit',
    name: 'edit course information',
    meta: { layout: 'app' },
    component: CourseEdit
  },
  {
    path: '/staff/reports',
    name: 'course reports',
    meta: { layout: 'app' },
    component: Reports
  },
  {
    path: '/staff/reports/closeout',
    name: 'closeout report',
    meta: { layout: 'app' },
    component: Closeout
  },
  {
    path: '/staff/reports/closeout/print',
    name: 'closeout report generator',
    meta: { layout: 'app' },
    component: CloseOutPrint
  },
  {
    path: '/staff/finances',
    name: 'course finances',
    meta: { layout: 'app' },
    component: Finances
  },
  {
    path: '/staff/list',
    name: 'staff list',
    meta: { layout: 'app', editPath: '/staff/list/edit' },
    component: StaffList
  },
  {
    path: '/staff/list/edit',
    name: 'edit staff list',
    meta: { layout: 'app' },
    component: StaffListEdit
  },
  {
    path: '/staff/staff-bios',
    name: 'staff bios',
    meta: { layout: 'app' },
    component: StaffBios
  },
  {
    path: '/staff/participants',
    name: 'participant list',
    meta: { layout: 'app', editPath: '/staff/participants/edit' },
    component: ParticipantList
  },
  {
    path: '/staff/participants/edit',
    name: 'edit participant list',
    meta: { layout: 'app' },
    component: ParticipantListEdit
  },
  {
    path: '/staff/participant-bios',
    name: 'participant photos',
    meta: { layout: 'app' },
    component: ParticipantBios
  },
  {
    path: '/staff/patrols',
    name: 'patrols',
    meta: { layout: 'app', editPath: '/staff/patrols/edit' },
    component: Patrols
  },
  {
    path: '/staff/patrols/edit',
    name: 'edit patrols',
    meta: { layout: 'app' },
    component: PatrolsEdit
  },
  {
    path: '/staff/ticket-goals',
    name: 'ticket goal list',
    meta: { layout: 'app', editPath: '/staff/ticket-goals/edit' },
    component: TicketList
  },
  {
    path: '/staff/ticket-goals/edit',
    name: 'edit ticket counselor',
    meta: { layout: 'app' },
    component: TicketListEdit
  },
  {
    path: '/staff/participant-ticket',
    name: 'participant ticket',
    meta: { layout: 'app' },
    component: Ticket
  },
  {
    path: '/staff/personal',
    name: 'resource questionnaire',
    meta: { layout: 'app' },
    component: Personal
  },
  {
    path: '/staff/participant',
    name: 'resource questionnaire',
    meta: { layout: 'app' },
    component: Personal
  },
  {
    path: '/staff/precourse',
    name: 'Personal Reflection Assignment',
    meta: { layout: 'app' },
    component: PreCourseAssignment
  },
  {
    path: '/staff/staff-dev',
    name: 'staff development agendas',
    meta: { layout: 'app', editPath: '/staff/staff-dev/edit' },
    component: StaffDev
  },
  {
    path: '/staff/staff-dev/edit',
    name: 'edit staff development agendas',
    meta: { layout: 'app' },
    component: StaffDevEdit
  },
  {
    path: '/staff/course-schedule',
    name: 'course schedule',
    meta: { layout: 'app', editPath: '/staff/course-schedule/edit' },
    component: CourseSchedule
  },
  {
    path: '/staff/course-schedule/edit',
    name: 'edit course schedule',
    meta: { layout: 'app' },
    component: CourseScheduleEdit
  },
  {
    path: '/staff/presentations',
    name: 'presentation assignments',
    meta: { layout: 'app', editPath: '/staff/presentations/edit' },
    component: Presentations
  },
  {
    path: '/staff/presentations/edit',
    name: 'edit presentation assignments',
    meta: { layout: 'app' },
    component: PresentationsEdit
  },
  {
    path: '/staff/packing-list',
    name: 'packing list',
    meta: { layout: 'app', editPath: '/staff/packing-list/edit' },
    component: PackingList
  },
  {
    path: '/staff/packing-list/edit',
    name: 'edit packing lists',
    meta: { layout: 'app' },
    component: PackingListEdit
  },
  {
    path: '/staff/faqs',
    name: 'faqs',
    meta: { layout: 'app', editPath: '/staff/faqs/edit' },
    component: Faqs
  },
  {
    path: '/staff/faqs/edit',
    name: 'edit faqs',
    meta: { layout: 'app' },
    component: FaqsEdit
  },
  {
    path: '/staff/links',
    name: 'links and files',
    meta: { layout: 'app', editPath: '/staff/links/edit' },
    component: Links
  },
  {
    path: '/staff/links/edit',
    name: 'edit links and files',
    meta: { layout: 'app' },
    component: LinksEdit
  },
  {
    path: '/staff/support',
    name: 'staff support info',
    meta: { layout: 'app' },
    component: Help
  }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/create-course', '/', '/home', '/invitation', '/forgot-password']
  const authRequired = !publicPages.includes(to.path)

  if (authRequired && !router.app.isLoggedIn) {
    return next('/login')
  }

  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
